export const ADD_PRODUCT_HELP = {
  name: "Short display name in English that the users will see. Existing examples: 'Football', 'Beach tennis'",
  description: 'Description in English. Take inspiration from the descriptions of the existing products',
  maxRentTimeInMinutes: 'Most common value: 360',
  translationKey:
    "Use lowercase with underscore spacing. Existing examples: 'football', 'beach_tennis'. Make sure that this translation key does not already exist!",
  imageName:
    "Exactly the same as the translation key. If you don't have an image, you may use one of the 'generic_' image names. The image shows up as soon as the dev team has uploaded it — here, on the web site, and in the app. No release needed anywhere.",
  priceWeight: '',
  rentalType: '',
  showInApi:
    'If enabled, this product will be exposed in the server API. The most important consequence of this is that the product will be visible on the Piffl web site',
} as const
